import { Box, styled } from '@mui/material'
import Grid from '@mui/material/Grid2'

export const LeftPictureGrid = styled(Grid)`
  width: 0;

  ${(props) => props.theme.breakpoints.up('sm')} {
    width: 120px;
  }

  ${(props) => props.theme.breakpoints.up('lg')} {
    width: 400px;
  }

  ${(props) => props.theme.breakpoints.up(1600)} {
    width: 400px;
  }
`

export const LogoPictureWrapper = styled(Box)`
  position: absolute;
  left: 33px;
  top: auto;
  bottom: 12px;
  transform: none;
  @media (max-height: 498px) {
    top: 51px;
  }

  ${(props) => props.theme.breakpoints.up('lg')} {
    left: 78px;
    top: auto;
    bottom: 12px;
  }
`

export const LogoPicture = styled('picture')`
  display: block;
  width: 60px;
  height: 37px;

  ${(props) => props.theme.breakpoints.up('lg')} {
    width: 243px;
    height: 48px;
  }
`

export const LeftImgPicture = styled('picture')`
  display: block;
  width: 0;
  height: 100%;
  position: relative;

  img {
    object-fit: cover;
  }

  ${(props) => props.theme.breakpoints.up('sm')} {
    width: 120px;
  }

  ${(props) => props.theme.breakpoints.up('lg')} {
    width: 400px;
  }

  ${(props) => props.theme.breakpoints.up(1600)} {
    width: 400px;
  }
`

export const FixedPictureWrapper = styled(Box)`
  position: fixed;
  height: 100vh;
  width: 100%;
`

export const LayoutWrapper = styled(Box)`
  display: flex;
  min-height: 100vh;
`

export const ContentBox = styled(Box)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-basis: 0;
  width: 100%;
  min-width: 50%;
  max-width: 1600px;
`
